import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyCropReconcilliationListing } from './Pages'

export const DailyCropReconcilliationRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DailyCropReconcilliationListing} />
    </Fragment>
)